import FormPacoteInteligente from 'src/components/pacoteInteligente/FormPacoteInteligente'

function formPacote() {
  return <FormPacoteInteligente />
}

export default formPacote
